// extracted by mini-css-extract-plugin
export var checkbox = "_43-0";
export var circle = "_43-3";
export var horizontalContainer = "_43-7";
export var sm = "_43-5";
export var switch0 = "_43-2";
export var switchDisabled = "_43-8";
export var switchEnabled = "_43-1";
export var textSwitchContainer = "_43-9";
export var textSwitchOption = "_43-a";
export var textSwitchOptionSelected = "_43-b";
export var verticalContainer = "_43-6";
export var xs = "_43-4";